import React from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { permissions } from './permissions';
import { PermissionGuard } from '~/core/PermissionGuard';
import { Route as FundingRequestContainerRoute } from '~/core/routes/settings/funding-requests/_index';
import { Route as WorkflowAuthorExistingTemplateRoute } from '~/core/routes/settings/funding-requests/workflow/[workflowTemplateId]/_index';
import { Route as WorkflowAuthorNewTemplateRoute } from '~/core/routes/settings/funding-requests/workflow/new/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <PermissionGuard
      permissions={permissions}
      fallback={<Navigate to="/settings" replace />}
    >
      <Outlet />
    </PermissionGuard>
  ),
  // Relative to /settings/funding-requests/*
  children: [
    {
      index: true,
      element: <FundingRequestContainerRoute />,
    },
    {
      path: 'workflow/new',
      element: <WorkflowAuthorNewTemplateRoute />,
    },
    {
      path: 'workflow/:workflowTemplateId',
      element: <WorkflowAuthorExistingTemplateRoute />,
    },
  ],
};
